module.exports = __webpack_public_path__ + "6e2257939a120fe969dded98922e91e1.png";